export default __webpack_public_path__ + "static/media/cukeitall.9c127ea0.png";